import React, { useId } from "react";
import { COLORS } from "../../theme";

// Cabeçalho com fundo em onda — mesma peça visual do app mobile (ver
// mobile/src/components/OndaCabecalho.js), portada pra SVG de verdade em vez
// de react-native-svg. `height` é a altura total (incluindo a curva), o
// conteúdo (children) fica por cima, em fluxo normal. ID do gradiente é
// único por instância (useId) — SVG não aceita dois <linearGradient> com o
// mesmo id na mesma página, e essa peça pode aparecer em mais de uma tela.
export default function OndaCabecalho({ height = 190, children, style, className }) {
  const gradId = `onda-grad-${useId()}`;
  return (
    <div className={className} style={{ position: "relative", height, ...style }}>
      <svg
        width="100%"
        height={height}
        viewBox={`0 0 100 ${height}`}
        preserveAspectRatio="none"
        style={{ position: "absolute", inset: 0, display: "block" }}
      >
        <defs>
          <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor={COLORS.primaryDark} />
            <stop offset="1" stopColor={COLORS.primary} />
          </linearGradient>
        </defs>
        <path d={`M0,0 L100,0 L100,${height - 50} Q50,${height - 10} 0,${height - 50} Z`} fill={`url(#${gradId})`} />
      </svg>
      <div style={{ position: "relative", height: "100%" }}>{children}</div>
    </div>
  );
}
